<template lang="pug">
el-footer(style="height:40px;")
  p &copy; conol,inc.
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.el-footer {
  font-size: 13px;
  text-align: center;
}

</style>